import { useResourceContext } from "react-admin";
import { elemLabel, NoAccess } from "./noAccess";
import { useMyContext } from "../components/myContext";

export const WithPermissions = ({
  can,
  resource,
  action,
  children,
  label,
  className,
  fail,
}) => {
  const { acp } = useMyContext();
  resource = resource || useResourceContext();
  can = can || { resource, action };
  label = label || elemLabel(children, "WithPermissions", className);

  if (acp.can(can, label)) {
    return <>{children}</>;
  } else {
    return (
      <>
        {fail}
        <NoAccess label={label} can={can} />
      </>
    );
  }
};
